import {getSiblings} from './Helpers';
import {slice} from './Helpers';
import fetch from 'whatwg-fetch';
import Handlebars from 'handlebars/dist/handlebars';
import 'TweenMax';

var speakerModal = function() {

	var
		rawTemplate,
		template,
		profiles,
		body,
		closeButton,
    modalOpen,
		modalWrap;

	var _init = function() {
		rawTemplate   				= document.getElementById('m-programModal').innerHTML;
		template							= Handlebars.compile( rawTemplate );
		profiles              = document.querySelectorAll('.m-programItem');
		profiles              = slice.call( profiles );
		body                  = document.querySelector('body');
		closeButton           = undefined;
		modalWrap             = document.querySelector('.m-modalProgram__wrap'),
		modalOpen				 = false;

		_addEventListeners();
		_getData();

	}

	var _addEventListeners = function() {

		// Any mouse click on overlay closes it
		modalWrap.addEventListener('click', _onModalWrapClick);

		// Listen for ESC key to close overlay
   	document.addEventListener('keyup', _onDocumentKeyUp);

	}

	var _onModalWrapClick = function() {

		if(!modalOpen)
    		return;
    	
		_closeModal();
	}

	var _onDocumentKeyUp = function(e) {
    
    	if(!modalOpen)
    		return;

		var code = (e.keyCode ? e.keyCode : e.which);

		if (code === 27) {
			_closeModal();
		}

  }

	var _getData = function() {
		if (typeof SPEAKERS != 'undefined') {
			_populate(SPEAKERS);
		}

		// window.fetch('../../content/themes/emerceeday/assets/js/standalone/program.json')
		// 	.then( function( response ) {
		// 		return response.json();
		// 	}).then( function(json ) {
		// 		_populate( json );
		// 	}).catch( function( ex ) {
		// 		console.log( 'parsing failed', ex );
		// 	});
	}

	var _populate = function( data ) {
		profiles.forEach(function( element, index ) {
			element.addEventListener( 'click', function() {
				// e.preventDefault();

				_newPersonInfo( this, data );
			}, false);
		});
	}

	var _newPersonInfo = function( self, data ) {
		var currentID = parseInt( self.getAttribute('data-id') );
		data.forEach( function( element ) {

			if( currentID === element.id ) {
				var html = template( element );
				modalWrap.innerHTML += html;
				TweenLite.to( '.m-modalProgram', 0.3, { autoAlpha:1, onComplete: function() { body.style.overflowY='hidden'; } } );
				modalOpen = true;
			}
		});

		closeButton = document.querySelector( '.m-modalProgram__close' );
		closeButton.addEventListener( 'click', _closeModal, false );
	}

	var _closeModal = function() {
		var elem = document.querySelector('.m-modalProgram');
		TweenLite.to( '.m-modalProgram', 0.3, { autoAlpha: 0,  onComplete: function() { body.style.overflowY='auto'; } } );

		setTimeout(function(){
			elem.parentNode.removeChild(elem);
			modalOpen = false;
		}, 300);
	}

	return {
		init: _init
	}

}();

var speakerModalId = document.querySelector( '#m-programModal' );

if( speakerModalId ) {

	speakerModal.init();

}



// WEBPACK FOOTER //
// ./resources/assets/js/partials/ProgramModal.js